import { Meeting } from '@consigli/types';

import { toMsTimestamp } from '../format-meeting-datetime';

export type TranscriptStatus = 'ready' | 'not-run' | null;

const hasEnded = (meeting: Pick<Meeting, 'scheduledEndTime' | 'realEndTime'>): boolean => {
  const end = meeting.realEndTime || meeting.scheduledEndTime;
  if (!end) return false;

  const endTime = toMsTimestamp(end);
  return !Number.isNaN(endTime) && endTime < Date.now();
};

export const getTranscriptStatus = (
  meeting: Pick<Meeting, 'scheduledEndTime' | 'realEndTime' | 'hasTranscription'>,
): TranscriptStatus => {
  if (meeting.hasTranscription) return 'ready';
  return hasEnded(meeting) ? 'not-run' : null;
};

/** True when any meeting in the list is over and still waiting for its transcript. */
export const hasPendingTranscripts = (
  meetings: Pick<Meeting, 'scheduledEndTime' | 'realEndTime' | 'hasTranscription'>[],
): boolean => meetings.some((meeting) => getTranscriptStatus(meeting) === 'not-run');
